import {
	FlexButton,
	MimaButton,
	MimaText,
	Modal,
	MimaDropdown,
} from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import { amountFormatter } from '../../utils/utils';
import { payrollStore } from '../../stores';
import React, { useState } from 'react';
import moment from 'moment';

const ViewPayroll = ({
	closeModal,
	groupPayrollsList,
	monthPayroll,
	showMonthPayroll,
	payrollSummary,
	showPayrollSummary,
	prevPayBreakdown,
	showPrevPayBreakdown,
}) => {
	const [selectedPayrollList, setSummary] = useState({});
	const [selectedPayrollSummary, setPayrollSummary] = useState({});
	const [selectedPayroll, setPayroll] = useState({});
	return (
		<Modal closeModal={closeModal}>
			<>
				{!monthPayroll && !payrollSummary && !prevPayBreakdown && (
					<div className={styles.gp}>
						{groupPayrollsList.length === 0 ? (
							<MimaText variant="subtitle" align="center" mb={1}>
								No Previous Payroll Summary
							</MimaText>
						) : (
							<>
								<MimaText variant="subtitle" align="center" mb={4}>
									View Payroll
								</MimaText>

								{groupPayrollsList.map(summary => (
									<FlexButton
										title={moment(summary.month).format('MMMM, YYYY')}
										mt={2}
										key={summary.date}
										onClick={() => {
											setSummary(summary);
											setPayrollSummary(
												payrollStore.payrollSummaries.filter(
													sum => sum.date === summary.month
												)[0]
											);
											showMonthPayroll();
										}}
									/>
								))}
							</>
						)}
					</div>
				)}

				{monthPayroll && (
					<div className={styles.gp}>
						<MimaText variant="subtitle" align="center" mb={2}>
							{`Payroll for ${moment(selectedPayrollList.payrolls.payDay)
								.startOf('month')
								.format('Do MMMM, YYYY')} to ${moment(
								selectedPayrollList.payrolls.payDay
							)
								.endOf('month')
								.format('Do MMMM, YYYY')}`}
						</MimaText>
						<MimaDropdown
							labelTitle="Select Project/Tag"
							placeholder="Select Project/Tag"
						/>
						<MimaDropdown
							labelTitle="Select Department"
							placeholder="Select Department"
						/>
						<MimaText mt={4} mb={2} variant="smallBold" align="center">
							Currently Viewing All Employee Payroll List
						</MimaText>
						<div className={styles.gp__vps}>
							<MimaButton
								title="View Payroll Summary"
								variant="text"
								onClick={showPayrollSummary}
							/>
						</div>
						<table>
							<thead>
								<tr>
									<th> Name </th>
									<th> Gross Salary </th>
									<th> Net Salary </th>
									<th> Status </th>
								</tr>
							</thead>
							<tbody>
								{selectedPayrollList.payrolls.map(payroll => (
									<tr
										key={payroll._id}
										onClick={() => {
											setPayroll(payroll);
											showPrevPayBreakdown();
										}}>
										<td>
											{`${payroll.user[0].firstname} ${payroll.user[0].lastname}`}{' '}
										</td>
										<td> {amountFormatter().format(payroll.grossPay)}</td>
										<td> {amountFormatter().format(payroll.netPay)} </td>
										<td> {payroll.status} </td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}

				{payrollSummary && (
					<div className={styles.ps}>
						<MimaText variant="subtitle" align="center" mb={1}>
							Payroll Summary
						</MimaText>
						<MimaText labelTitle="Your Total Payroll Net cost" mb={2}>
							{amountFormatter().format(selectedPayrollSummary.totalNet)}
						</MimaText>
						<MimaText labelTitle="Pay Day" mb={2}>
							{moment(selectedPayrollSummary.payDay).format('Do MMMM, YYYY')}
						</MimaText>
						<MimaText labelTitle="Number of Employees" mb={2}>
							{`Total Employees ${selectedPayrollSummary.totalEmployees}`}
						</MimaText>
						<div className={styles.ps__breakdown}>
							<table>
								<thead>
									<tr className={styles.ps__breakdown_bdr}>
										<th>Breakdown</th>
										<th>Amount</th>
									</tr>
								</thead>
								<tbody>
									<tr className={styles.ps__breakdown_bdr}>
										<td>Salary Gross</td>
										<td>
											{amountFormatter().format(
												selectedPayrollSummary.totalInitialGrossPay
											)}
										</td>
									</tr>
									<tr className={styles.ps__breakdown_sm}>
										<td>PAYE Tax</td>
										<td>
											-
											{amountFormatter().format(
												selectedPayrollSummary.totalTax
											)}
										</td>
									</tr>
									<tr className={styles.ps__breakdown_sm}>
										<td>WHT</td>
										<td>
											-
											{amountFormatter().format(
												selectedPayrollSummary.totalWHT
											)}
										</td>
									</tr>
									<tr
										className={`${styles.ps__breakdown_sm} ${styles.ps__breakdown_bdr}`}>
										<td>NHF</td>
										<td>
											-
											{amountFormatter().format(
												selectedPayrollSummary.totalNHF
											)}
										</td>
									</tr>
									<tr
										className={`${styles.ps__breakdown_sm} ${styles.ps__breakdown_bdr}`}>
										<td>Pension</td>
										<td>
											-
											{amountFormatter().format(
												selectedPayrollSummary.totalPension
											)}
										</td>
									</tr>

									{selectedPayrollSummary.deductions.map(deduction => (
										<tr className={styles.ps__breakdown_sm}>
											<td>{deduction.type}</td>
											<td>-{amountFormatter().format(deduction.amount)}</td>
										</tr>
									))}
									<tr
										className={`${styles.ps__breakdown_sm} ${styles.ps__breakdown_bdr}`}>
										<td>Other Deductions</td>
										<td>
											-
											{amountFormatter().format(
												selectedPayrollSummary.totalOtherDeductions
											)}
										</td>
									</tr>


									{selectedPayrollSummary.additions.map(sum => (
										<tr key={sum.month} className={styles.ps__breakdown_sm}>
											<td>{sum.type}</td>
											<td>{amountFormatter().format(sum.amount)}</td>
										</tr>
									))}
									<tr>
										<th>Total</th>
										<th>
											{amountFormatter().format(
												selectedPayrollSummary.totalNet
											)}
										</th>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				)}

				{prevPayBreakdown && (
					<div className={styles.ps}>
						<MimaText variant="subtitle" align="center" mb={4}>
							{`${moment(selectedPayrollList.payrolls.payDay)
								.startOf('month')
								.format('Do MMMM, YYYY')} Pay Details`}
						</MimaText>

						<MimaText labelTitle="Name" mb={2}>
							{`${selectedPayroll.user[0].firstname} ${selectedPayroll.user[0].lastname}`}{' '}
						</MimaText>
						<MimaText labelTitle="Initial Gross Salary" mb={2}>
							{amountFormatter().format(selectedPayroll.initialGross || 0)}
						</MimaText>
						<MimaText labelTitle="Gross Salary" mb={2}>
							{amountFormatter().format(selectedPayroll.grossPay || 0)}
						</MimaText>
						{selectedPayroll.payAdditions.map(pay => (
							<MimaText labelTitle={pay.type} mb={2}>
								{amountFormatter().format(pay.amount || 0)}
							</MimaText>
						))}
						<MimaText labelTitle="Net Salary" mb={2}>
							{amountFormatter().format(selectedPayroll.netPay || 0)}
						</MimaText>
						<MimaText labelTitle="PAYE Tax" mb={2}>
							{amountFormatter().format(selectedPayroll.tax || 0)}
						</MimaText>
						<MimaText labelTitle="WHT" mb={2}>
							{amountFormatter().format(selectedPayroll.wht || 0)}
						</MimaText>
						<MimaText labelTitle="Pension" mb={2}>
							{amountFormatter().format(selectedPayroll.pension || 0)}
						</MimaText>
						<MimaText labelTitle="NHF" mb={2}>
							{amountFormatter().format(selectedPayroll.nhf || 0)}
						</MimaText>

						{selectedPayroll.payDeductions.map(pay => (
							<MimaText labelTitle={pay.type} mb={2}>
								{`-${amountFormatter().format(pay.amount || 0)}`}
							</MimaText>
						))}
						<MimaText labelTitle="Other Deductions:" mb={2}>
							{amountFormatter().format(
								selectedPayroll.otherDeductionAmount || 0
							)}
						</MimaText>
						<MimaText labelTitle="Status" mb={2}>
							{selectedPayroll.status}
						</MimaText>
						<MimaText labelTitle="Approved Date" mb={2}>
							{selectedPayroll?.approver
								? moment(selectedPayroll?.approver?.date).format(
										'Do MMMM, YYYY'
								  )
								: ''}
						</MimaText>
						<MimaText labelTitle="Paid Date" mb={2}>
							{selectedPayroll.actualPaidDate
								? moment(selectedPayroll.actualPaidDate).format('Do MMMM, YYYY')
								: ''}
						</MimaText>
					</div>
				)}
			</>
		</Modal>
	);
};

export default ViewPayroll;
